import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Automobilia } from '../../models/automobilia.model';
import { SwiperComponent, SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ContactService } from '../../services/contact.service';
import { Router } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-automobilia-teaser',
  templateUrl: './automobilia-teaser.component.html'
})
export class AutomobiliaTeaserComponent implements OnInit {

  @Input() data: Automobilia;

  public swiperConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    init: true,
    slidesPerView: 1,
    effect: 'fade'
  };

  swiperIndex = 0;

  @ViewChild('swiper', { static: true }) swiper: SwiperComponent;

  constructor(private router: Router, private contactService: ContactService, private translate: TranslateService) {
  }

  ngOnInit() {
  }

  prevImg() {
    if (this.swiperIndex > 0) {
      this.swiperIndex -= 1;
    }
  }

  nextImg() {
    if (this.swiperIndex + 1 < this.data.images.length) {
      this.swiperIndex += 1;
    }
  }

  requestAutomobilia() {
    this.contactService.automobilia = this.data;
    this.router.navigate(['/contact/automobilia', this.data.id]).then();
  }

}
